import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["key"];
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default function getComponentFromLookup(COMPONENTS, lookup, defaultLookup, props) {
  var Component = COMPONENTS[lookup || defaultLookup].component;
  // `key` must reach JSX directly: spread, React 18.3 warns and React 19 drops it.
  var _ref = props !== null && props !== void 0 ? props : {},
    key = _ref.key,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Component, _extends({}, rest), key);
}